// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJK4p","colBig":"styles_colBig__1aVp-","colSmall":"styles_colSmall__3jYAn"};